var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"libraryContainer"}},[_c('h6',{staticStyle:{"position":"fixed","text-align":"center","top":"50px"}},[_vm._v(" Your library ")]),(!_vm.isConnectedToSpotify)?_c('connect-to-spotify'):_c('sub-library')],1)}
var staticRenderFns = []

export { render, staticRenderFns }